import baseScmService from 'services/baseScmService';

const interviewbitTestGroupService = baseScmService.injectEndpoints({
  endpoints: (build) => ({
    getInterviewbitTestGroup: build.query({
      query: ({ testGroupId, courseType }) => ({
        method: 'GET',
        url: `/interviewbit-test-groups/${testGroupId}`,
        params: {
          course_type: courseType,
        },
      }),
    }),
    bulkUpdateInterviewbitTests: build.mutation({
      query: (payload) => ({
        method: 'POST',
        url: `/interviewbit-test-groups/bulk-update`,
        body: payload,
      }),
      invalidatesTags: (result, error, { sbatGroup }) =>
        error ? [] : [{ type: 'SbatGroup', id: sbatGroup.id }],
    }),
  }),
  overrideExisting: false,
});

export const {
  useLazyGetInterviewbitTestGroupQuery,
  useBulkUpdateInterviewbitTestsMutation,
} = interviewbitTestGroupService;

export default interviewbitTestGroupService;
